import { CheckIcon } from '@heroicons/react/24/solid'

export const ArrowProgressBar = ({ steps }) => {
  return (
    <div className="w-full">
      <ol role="list" className="rounded-md bg-perception-black-800 flex flex-col overflow-hidden">
        {steps.map((step, stepIdx) => (
          <li key={step.name} className="relative pr-3">
            {step.status === 'complete' ? (
              <div className="group flex w-full items-center h-full">
                <span className="flex items-center px-6 py-4 text-4xl font-medium">
                  <span className="flex size-16 shrink-0 items-center justify-center rounded-full bg-perception-success-300">
                    <CheckIcon aria-hidden="true" className="size-10 text-white" />
                  </span>
                  <span className="ml-4 text-4xl font-medium text-white">{step.name}</span>
                </span>
              </div>
            ) : step.status === 'current' ? (
              <div aria-current="step" className="flex items-center px-6 py-4 text-4xl font-medium h-full">
                <span className="flex size-16 shrink-0 items-center justify-center rounded-full border-2 border-perception-blue">
                  <span className="text-perception-blue">{step.id}</span>
                </span>
                <span className="ml-4 text-4xl font-medium text-perception-blue truncate whitespace-nowrap">{step.name}</span>
              </div>
            ) : (
              <div className="group flex items-center h-full">
                <span className="flex items-center px-6 py-4 text-4xl font-medium">
                  <span className="flex size-16 shrink-0 items-center justify-center rounded-full border-2 border-perception-gray-500">
                    <span className="text-perception-gray-500">{step.id}</span>
                  </span>
                  <span className="ml-4 text-4xl font-medium text-perception-gray-500">{step.name}</span>
                </span>
              </div>
            )}

            {/*{stepIdx !== steps.length - 1 ? (*/}
            {/*  <>*/}
            {/*    /!* Arrow separator for lg screens and up *!/*/}
            {/*    <div aria-hidden="true" className="absolute right-0 top-0 hidden h-full w-5 md:block">*/}
            {/*      <svg fill="none" viewBox="0 0 22 80" preserveAspectRatio="none" className="size-full text-perception-black-700">*/}
            {/*        <path*/}
            {/*          d="M0 -2L20 40L0 82"*/}
            {/*          stroke="currentcolor"*/}
            {/*          vectorEffect="non-scaling-stroke"*/}
            {/*          strokeLinejoin="round"*/}
            {/*        />*/}
            {/*      </svg>*/}
            {/*    </div>*/}
            {/*  </>*/}
            {/*) : null}*/}
          </li>
        ))}
      </ol>
    </div>
  )
}
